import React, { useId } from "react";
import "./PageLoader.css";

interface PageLoaderProps {
  message?: string;
}

/* Nedaris N monogramı "dokunarak" yüklenir — geometri public/brand/nedaris-mark.svg ile birebir.
   Lacivert karenin içinde 37 sönük çözgü (dikey iplik); N kırpmasındaki iplikler soldan sağa
   sırayla "kalkar" (parlar), sonra söner ve döngü başa döner. Atkı (yatay ince çizgi) N'nin
   içinde yukarıdan aşağı süzülür. Login sayfasındaki Loom ile aynı dil; yalnız SVG + CSS. */
const XS = Array.from({ length: 37 }, (_, i) => 76 + i * 10);

const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Yükleniyor...",
}) => {
  // useId çıktısındaki ":" karakterleri url(#…) içinde kırılır → temizle
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  const threads = (y1: number, y2: number) =>
    XS.map((x, i) => (
      <line key={x} x1={x} y1={y1} x2={x} y2={y2} style={{ ["--i" as string]: i } as React.CSSProperties} />
    ));

  return (
    <div className="page-loader-overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="page-loader-content">
        <svg className="page-loader-mark" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
          <defs>
            <clipPath id={`${id}-n`}>
              <rect x="163" y="148" width="37" height="216" />
              <rect x="312" y="148" width="37" height="216" />
              <polygon points="163,148 200,148 349,364 312,364" />
            </clipPath>
          </defs>
          <rect className="pl-frame" x="76" y="76" width="360" height="360" rx="8" />
          <rect className="pl-spine" x="252.5" y="76" width="7" height="360" />
          <g className="pl-warp">{threads(76, 436)}</g>
          <g className="pl-lift" clipPath={`url(#${id}-n)`}>{threads(148, 364)}</g>
          <g clipPath={`url(#${id}-n)`}>
            <rect className="pl-weft" x="76" y="0" width="360" height="3" />
          </g>
        </svg>
        <p className="page-loader-message">{message}</p>
      </div>
    </div>
  );
};

export default PageLoader;
